import { render, staticRenderFns } from "./ItemIssueHistory.vue?vue&type=template&id=c4c84e5c&"
import script from "./ItemIssueHistory.vue?vue&type=script&lang=js&"
export * from "./ItemIssueHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports